module.exports = __webpack_public_path__ + "img/about_001.57e346d.webp";